export default __webpack_public_path__ + "static/media/gymstats-demo.b70fcbc0.gif";